// extracted by mini-css-extract-plugin
module.exports = {"DomainList":"DomainList_DomainList__20x3E","Buttons":"DomainList_Buttons__2M4TC"};